export const SentimentEmoji = {
  positive: '😊',
  neutral: '😐',
  negative: '😞',
};
export const SentimentColor = {
  positive: '#29a3a3',
  neutral: '#D6B862',
  negative: '#a32929',
};
export const mediaType = {
  audio: 'audio',
  video: 'video',
};
export function formatInTitleCase(str) {
  if (!str || typeof str !== 'string' || str.trim() === '') {
    return '';
  }
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
export function formatMsToMin(ms) {
  if (ms == null || isNaN(ms)) {
    return '--:--';
  }
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  const ss = String(s).padStart(2, '0');

  return `${m}:${ss}`;
}

export const newChat = 'new-conversation';
